import React from 'react'
import { Col } from 'react-bootstrap'
import TopBar from './top-bar'
import Content from './content'

import './style.scss'

const Index = () => {
	return(
		<Col md={4} className="dashboard-overview-new-sales-container">
			<Col className="inner-dashboard-overview-new-sales-container">
				<TopBar/>
                <Content/>
			</Col>
		</Col>
	)
}

export default Index